import _get from 'lodash/get';

import { dateStringRegEx } from './dateStringRegEx';

const monthNameMap = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
};

export const getDateParts = (string?: Maybe<string>): DateParts | null => {
    if (!string) {
        return null;
    }

    const matchResults = string.match(dateStringRegEx);

    if (matchResults === null) {
        return null;
    }

    const month = matchResults?.[2] ?? null;

    if (month === null) {
        return null;
    }

    const monthName = _get(monthNameMap, [month], '');

    return {
        year: matchResults[1],
        month,
        monthName,
        day: matchResults[3],
    };
};
